// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 20px;
  padding-bottom: 60px;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: var(--background-default);
}
.wrapper .header-wrapper {
  text-align: center;
  width: 100%;
}
.wrapper .title {
  font-family: AppFontBold, sans-serif;
  width: 100%;
  font-size: 22px;
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  text-align: start;
  padding: 20px 0px 10px;
  text-transform: uppercase;
  text-align: center;
}
.wrapper .description {
  font-family: AppFont;
  font-size: 14px;
  color: var(--ion-color-secondary);
  padding: 5px 0px 10px;
  text-align: center;
}
.wrapper ion-col .card-item {
  position: relative;
  margin: 0 auto;
  flex-grow: 1;
  min-height: 100%;
  word-break: break-word;
  background: white;
  border: 2px solid white;
  border-radius: var(--custom-border-radius);
  box-shadow: 0px 2.1px 7.87px 0px rgba(13, 71, 161, 0.1490196078);
  transition: border 200ms linear;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.wrapper ion-col .card-item.selected {
  background: rgba(216, 11, 49, 0.3568627451);
  border: 2px solid var(--ion-color-primary);
  background: #f6faf6;
}
.wrapper ion-col .card-item .default-img {
  padding: 5px;
  object-fit: contain !important;
  background-color: #fff;
}
.wrapper ion-col .card-item .image-block {
  width: 100%;
  position: relative;
  margin-bottom: 8px;
}
.wrapper ion-col .card-item .image-block ion-img {
  width: 100%;
  height: 100%;
  aspect-ratio: 512/371;
  object-fit: contain;
}
.wrapper ion-col .card-item .image-block .plus {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 32px;
  width: 32px;
}
.wrapper ion-col .card-item .info-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
.wrapper ion-col .card-item .info-block .name {
  height: 38px;
  font-family: AppFontBold, sans-serif;
  font-weight: 600;
  font-size: 15px;
  margin: 0;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 992px) {
  .wrapper ion-col .card-item .info-block .name {
    font-size: 13px;
    height: 32px;
    overflow: hidden;
  }
}
.wrapper ion-col .card-item .info-block .deposit_text {
  font-size: 9px;
  font-family: AppFont, sans-serif;
  color: #000000;
  margin: 0;
  margin-top: 20px;
  text-align: center;
}

.price {
  margin: 8px 0 0;
  font-weight: 600;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
  text-align: right;
  font-size: 16px;
  width: 90%;
}

.content_block {
  height: calc(100% - 124px);
  overflow-y: auto;
  width: 100%;
}

.footer-btn {
  position: fixed;
  bottom: 20px;
  left: 0px;
  right: 0px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.footer-btn ion-button {
  margin: 5px 0px;
  width: 90%;
  text-transform: uppercase;
  color: #fff;
  font-size: 16px;
  font-size: 15px;
  min-height: 36px;
}
.footer-btn ion-button.cancel-btn {
  --background: transparent;
  color: var(--ion-color-secondary);
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: left;
  padding-top: 6px;
}

.add-button {
  width: 100%;
  margin-top: 10px;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 8px;
  cursor: pointer;
}
.add-button p {
  font-family: AppFontBold;
  color: var(--ion-color-secondary);
  font-size: 14px;
}

.quantity-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.quantity-selector ion-icon {
  margin: 0px 6px;
  cursor: pointer;
}
.quantity-selector .quantity {
  color: var(--ion-color-secondary);
  font-size: 20px;
  font-family: AppFontBold;
}
.quantity-selector .quantity-btn {
  width: 30px;
  height: 30px;
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}

.selected_item_icon {
  position: absolute;
  top: 5px;
  left: 5px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}
.selected_item_icon.active {
  z-index: 99;
  opacity: 1;
}

.footer-section {
  padding: 5px 0px 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2CAAA;AADD;AAEC;EACC,kBAAA;EACA,WAAA;AAAF;AAEC;EACC,oCAAA;EACA,WAAA;EACA,eAAA;EAEA,yBAAA;EACA,iCAAA;EAEA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAFF;AAIC;EACC,oBAAA;EACA,eAAA;EACA,iCAAA;EACA,qBAAA;EACA,kBAAA;AAFF;AAKE;EACC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EAEA,0CAAA;EACA,gEAAA;EAEA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AALH;AAMG;EACC,2CAAA;EACA,0CAAA;EACA,mBAAA;AAJJ;AAOG;EACC,YAAA;EACA,8BAAA;EACA,sBAAA;AALJ;AAQG;EACC,WAAA;EACA,kBAAA;EACA,kBAAA;AANJ;AAYI;EACC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AAVL;AAYI;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAVL;AAcG;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AAZJ;AAaI;EACC,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iCAAA;EACA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAZL;AC/FE;ED2FE;IAmBE,eAAA;IACA,YAAA;IACA,gBAAA;EAXJ;AACF;AAaI;EACC,cAAA;EACA,gCAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AAXL;;AAiBA;EACC,eAAA;EACA,gBAAA;EACA,iCAAA;EACA,oCAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;AAdD;;AAgBA;EACC,0BAAA;EACA,gBAAA;EACA,WAAA;AAbD;;AAeA;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAZD;AAaC;EACC,eAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;EAKA,eAAA;EACA,gBAAA;AAfF;AAUE;EACC,yBAAA;EACA,iCAAA;AARH;;AAcA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAXD;;AAcA;EACC,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,4CAAA;EACA,kBAAA;EACA,eAAA;AAXD;AAaC;EACC,wBAAA;EACA,iCAAA;EACA,eAAA;AAXF;;AAcA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EAKA,YAAA;AAfD;AAWC;EACC,eAAA;EACA,eAAA;AATF;AAYC;EACC,iCAAA;EACA,eAAA;EACA,wBAAA;AAVF;AAYC;EACC,WAAA;EACA,YAAA;AAVF;AAWE;EACC,YAAA;AATH;;AAcA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;AAXD;AAaC;EACC,WAAA;EACA,UAAA;AAXF;;AAcA;EACC,qBAAA;AAXD","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\tpadding: 20px;\n\tpadding-bottom: 60px;\n\toverflow-x: hidden;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: var(--background-default);\n\t.header-wrapper {\n\t\ttext-align: center;\n\t\twidth: 100%;\n\t}\n\t.title {\n\t\tfont-family: AppFontBold, sans-serif;\n\t\twidth: 100%;\n\t\tfont-size: 22px;\n\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-secondary);\n\n\t\ttext-align: start;\n\t\tpadding: 20px 0px 10px;\n\t\ttext-transform: uppercase;\n\t\ttext-align: center;\n\t}\n\t.description {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tcolor: var(--ion-color-secondary);\n\t\tpadding: 5px 0px 10px;\n\t\ttext-align: center;\n\t}\n\tion-col {\n\t\t.card-item {\n\t\t\tposition: relative;\n\t\t\tmargin: 0 auto;\n\t\t\tflex-grow: 1;\n\t\t\tmin-height: 100%;\n\t\t\tword-break: break-word;\n\t\t\tbackground: white;\n\t\t\tborder: 2px solid white;\n\n\t\t\tborder-radius: var(--custom-border-radius);\n\t\t\tbox-shadow: 0px 2.1px 7.87px 0px #0d47a126;\n\n\t\t\ttransition: border 200ms linear;\n\t\t\ttext-align: center;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\t&.selected {\n\t\t\t\tbackground: #d80b315b;\n\t\t\t\tborder: 2px solid var(--ion-color-primary);\n\t\t\t\tbackground: #f6faf6;\n\t\t\t}\n\n\t\t\t.default-img {\n\t\t\t\tpadding: 5px;\n\t\t\t\tobject-fit: contain !important;\n\t\t\t\tbackground-color: #fff;\n\t\t\t}\n\n\t\t\t.image-block {\n\t\t\t\twidth: 100%;\n\t\t\t\tposition: relative;\n\t\t\t\tmargin-bottom: 8px;\n\n\t\t\t\t// &:has(.default_img) {\n\t\t\t\t// \tbackground-color: var(--ion-color-primary);\n\t\t\t\t// }\n\n\t\t\t\tion-img {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\taspect-ratio: 512 / 371;\n\t\t\t\t\tobject-fit: contain;\n\t\t\t\t}\n\t\t\t\t.plus {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 10px;\n\t\t\t\t\tright: 10px;\n\t\t\t\t\theight: 32px;\n\t\t\t\t\twidth: 32px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.info-block {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tflex-grow: 1;\n\t\t\t\t.name {\n\t\t\t\t\theight: 38px;\n\t\t\t\t\tfont-family: AppFontBold, sans-serif;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 15px;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\t\tword-break: break-word;\n\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\n\t\t\t\t\t@include mobile {\n\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\theight: 32px;\n\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.deposit_text {\n\t\t\t\t\tfont-size: 9px;\n\t\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\t\tcolor: #000000;\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.price {\n\tmargin: 8px 0 0;\n\tfont-weight: 600;\n\tcolor: var(--ion-color-secondary);\n\tfont-family: AppFontBold, sans-serif;\n\ttext-align: right;\n\tfont-size: 16px;\n\twidth: 90%;\n}\n.content_block {\n\theight: calc(100% - 124px);\n\toverflow-y: auto;\n\twidth: 100%;\n}\n.footer-btn {\n\tposition: fixed;\n\tbottom: 20px;\n\tleft: 0px;\n\tright: 0px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\talign-items: center;\n\tion-button {\n\t\tmargin: 5px 0px;\n\t\twidth: 90%;\n\t\ttext-transform: uppercase;\n\t\tcolor: #fff;\n\t\tfont-size: 16px;\n\t\t&.cancel-btn {\n\t\t\t--background: transparent;\n\t\t\tcolor: var(--ion-color-secondary);\n\t\t}\n\t\tfont-size: 15px;\n\t\tmin-height: 36px;\n\t}\n}\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: #9f9f9f;\n\ttext-align: left;\n\tpadding-top: 6px;\n}\n\n.add-button {\n\twidth: 100%;\n\tmargin-top: 10px;\n\tpadding: 5px 10px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 1px solid var(--ion-color-secondary);\n\tborder-radius: 8px;\n\tcursor: pointer;\n\n\tp {\n\t\tfont-family: AppFontBold;\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-size: 14px;\n\t}\n}\n.quantity-selector {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tion-icon {\n\t\tmargin: 0px 6px;\n\t\tcursor: pointer;\n\t}\n\tz-index: 999;\n\t.quantity {\n\t\tcolor: var(--ion-color-secondary);\n\t\tfont-size: 20px;\n\t\tfont-family: AppFontBold;\n\t}\n\t.quantity-btn {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\t&.add-opacity {\n\t\t\topacity: 0.5;\n\t\t}\n\t}\n}\n\n.selected_item_icon {\n\tposition: absolute;\n\ttop: 5px;\n\tleft: 5px;\n\topacity: 0;\n\ttransition: opacity 0.3s ease-in-out;\n\n\t&.active {\n\t\tz-index: 99;\n\t\topacity: 1;\n\t}\n}\n.footer-section {\n\tpadding: 5px 0px 10px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
